import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'
import Container from 'react-bootstrap/Container'

import { Edit as EditIcon } from 'react-feather';
import { Eye as EyeIcon } from 'react-feather';

const Ecoles = () => {
  const navigate = useNavigate()

  const { ecoles } = useContext(SuperAdminContext)

  const [ecolesAff, setEcolesAff] = useState([])
  const [sortByValue, setSortByValue] = useState("id")
  const [sortByOrder, setSortByOrder] = useState(true)

  useEffect(() => {
    if (ecoles?.length > 0) {
      sortBy(sortByValue)
    }
  }, [sortByValue, ecoles])

  const sortBy = (value) => {
    let newOrder = null;
    if (sortByValue === value) {
      newOrder = !sortByOrder
    } else {
      newOrder = true
    }

    let newArr = [...ecoles].sort(
      (a, b) => {
        if (a[value] < b[value]) {
          if (newOrder === true) {
            return -1
          } else {
            return 1
          }
        } else {
          if (newOrder === true) {
            return 1
          } else {
            return -1
          }
        }
      }
    )

    setSortByOrder(newOrder);
    setSortByValue(value);
    setEcolesAff(newArr);
  }


  return (
    <>
      <Helmet>
        <title>Admin Ecoles | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            title="Liste des Écoles"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { navigate('/admin/ecoles/add') }}
            >
              + École
            </Button>
          </TopBar>


          <Box sx={{
            padding:"10px 10px 30px 10px",
            display:"flex",
            width:"100%",
            justifyContent:"space-evenly",
            gap:"10px",
            flexWrap:"wrap"
          }}>
            <Container style={{minWidth:'800px', width:'100%'}}>
              <Row>
                <Table style={{margin:'auto', width:'100%'}}>
                  <thead>
                    <tr style={{height:'30px'}}>
                      <th
                        onClick={() => sortBy('id')}
                        style={{cursor:'pointer', userSelect:'none', color : sortByValue === 'id' ? 'red' : 'unset'}}
                      >
                        ID
                      </th>
                      <th
                        onClick={() => sortBy('name')}
                        style={{cursor:'pointer', userSelect:'none', color : sortByValue === 'name' ? 'red' : 'unset'}}
                      >
                        Nom
                      </th>
                      <th
                        onClick={() => sortBy('groupeNbr')}
                        style={{width:'80px', cursor:'pointer', userSelect:'none', color : sortByValue === 'groupeNbr' ? 'red' : 'unset'}}
                      >
                        Groupes
                      </th>
                      <th
                        onClick={() => sortBy('campusNbr')}
                        style={{width:'80px', cursor:'pointer', userSelect:'none', color : sortByValue === 'campusNbr' ? 'red' : 'unset'}}
                      >
                        Campus
                      </th>
                      <th style={{width:'50px'}}>Edit</th>
                      <th style={{width:'50px'}}>Voir</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ecolesAff?.map((ecole, index) => (
                      <tr key={index} style={{height:'30px', backgroundColor : index%2 == 0 ? '#F3F3F3' : 'white'}}>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {ecole?.id}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {ecole?.name}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {ecole?.groupeNbr}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {ecole?.campusNbr}
                        </td>
                        <td
                          style={{verticalAlign:"middle", textAlign:"center", paddingTop:'3px', cursor:"pointer"}}
                          onClick={() => {
                            navigate('/admin/ecoles/edit/'+ecole?.id)
                          }}
                        >
                          <EditIcon
                            color="black"
                            size={20}
                          />
                        </td>
                        <td
                          style={{verticalAlign:"middle", textAlign:"center", paddingTop:'3px', cursor:"pointer"}}
                          onClick={() => {
                            navigate('/admin/ecoles/results/'+ecole?.id)
                          }}
                        >
                          <EyeIcon
                            color="black"
                            size={20}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Row>
            </Container>
          </Box>

        </Box>
      </Box>
    </>
  )
};

export default Ecoles;
